import React from 'react';
import { Button } from '../ui/button';
import { bunnyFinalCTA } from '../../bunnyMock';
import { ArrowRight, Zap } from 'lucide-react';

const BunnyFinalCTASection = () => {
  return (
    <section className="section-spacing bunny-section-dark relative overflow-hidden">
      {/* Grid pattern overlay */}
      <div className="absolute inset-0 bunny-grid-bg opacity-10"></div>
      
      {/* Decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-10 left-10 w-96 h-96 bg-pink-400/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-72 h-72 bg-yellow-400/20 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-5xl mx-auto text-center relative z-10">
        {/* Icon */}
        <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-pink-400 to-yellow-400 rounded-full mb-10">
          <Zap className="w-10 h-10 text-white" />
        </div>

        {/* Headline */}
        <h2 className="text-5xl sm:text-6xl lg:text-7xl font-serif bunny-headline text-white mb-8 leading-tight">
          {bunnyFinalCTA.headline}
        </h2>

        {/* Message */}
        <p className="text-xl sm:text-2xl text-gray-300 font-sans mb-12 leading-relaxed max-w-3xl mx-auto">
          {bunnyFinalCTA.message}
        </p>

        {/* CTA Button */}
        <button className="bunny-btn-primary px-12 py-5 font-sans text-lg flex items-center gap-3 mx-auto mb-8">
          {bunnyFinalCTA.cta}
          <ArrowRight className="w-6 h-6" />
        </button>

        {/* Trust badges */}
        <div className="mt-16 flex flex-wrap justify-center items-center gap-8 text-sm font-sans font-bold tracking-wider text-gray-400">
          <div className="flex items-center gap-2">
            <span className="bunny-accent-pink text-xl">✓</span>
            <span>Free Shipping Over $50</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="bunny-accent-pink text-xl">✓</span>
            <span>30-Day Returns</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="bunny-accent-pink text-xl">✓</span>
            <span>Secure Checkout</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BunnyFinalCTASection;
